import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(1),
  alignItems: "flex-start",
}));
